export default "__VITE_PUBLIC_ASSET__c91ca7b3__"